import { backendPort } from "../components/Fungsiku";
import api from "../services/axiosInstance";

const MASTER_KEY = 'globalOpsi';
const TRIGER_KEY = 'trigerVersion';
let syncInFlight = null;

function getLocalMaster() {
  return JSON.parse(sessionStorage.getItem(MASTER_KEY) || localStorage.getItem(MASTER_KEY)) || {};
}

function getLocalTriger() {
  return JSON.parse(sessionStorage.getItem(TRIGER_KEY) || localStorage.getItem(TRIGER_KEY)) || {};
}

function saveLocalMaster(data) {
  sessionStorage.setItem(MASTER_KEY, JSON.stringify(data));
  localStorage.removeItem(MASTER_KEY);
}

function saveLocalTriger(data) {
  sessionStorage.setItem(TRIGER_KEY, JSON.stringify(data));
  localStorage.removeItem(TRIGER_KEY);
}

export async function syncMasterData() {
  return syncMasterDataWithOptions();
}

export async function syncMasterDataWithOptions(options = {}) {
  const force = Boolean(options?.force);
  const requestGroup = options?.requestGroup || 'master-sync';
  const timeout = Number(options?.timeout || 120000);
  if (!force && syncInFlight) {
    return syncInFlight;
  }

  if (force && syncInFlight) {
    await syncInFlight;
  }

  const request = (async () => {
    try {
      const localMaster = getLocalMaster();
      const localTriger = getLocalTriger();

      const res = await api.get(
        `${backendPort}/api/master/triger-version`,
        { requestGroup, timeout }
      );

      const serverTriger = res.data || {};
      const updatedMaster = { ...localMaster };
      let changed = false;

      for (const jenis in serverTriger) {
        if (force || localTriger[jenis] !== serverTriger[jenis]) {
          const dataRes = await api.get(
            `${backendPort}/api/master/master-data/${jenis}`,
            { requestGroup, timeout }
          );
          updatedMaster[jenis] = dataRes.data;
          changed = true;
        }
      }

      if (changed || force) {
        saveLocalMaster(updatedMaster);
        saveLocalTriger(serverTriger);
      }

      return updatedMaster;
    } catch (err) {
      console.error("syncMasterData error:", err.response?.data || err.message);
      return getLocalMaster();
    }
  })();

  if (!force) {
    syncInFlight = request.finally(() => {
      syncInFlight = null;
    });
    return syncInFlight;
  }

  return request;
}
